import { Inject, Injectable, Type } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { fromEvent } from "rxjs";
import { map } from "rxjs/operators";
import { ModalService, Modal, ModalRef } from '@app/modal';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from "@angular/core";
import { PusherService } from './pusher.service';

declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class HelperService {

  @BlockUI() blockUi?: NgBlockUI;

  constructor(
    private _router: Router,
    private modalService: ModalService,
    private toastrService: ToastrService,
    private sanitizer: DomSanitizer,
    private pusherService: PusherService,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  apiUrl(url: string) {
    return environment.apiEndpoint + url;
  }

  siteUrl(url: string) {
    return environment.frontend_url + url;
  }

  netOnline() {
    const source = fromEvent(window, 'online');
    return source.pipe(map(event => true));
  }

  netOffline() {
    const source = fromEvent(window, 'offline');
    return source.pipe(map(event => false));
  }

  blockUI(msg?: string) {
    this.blockUi!.start(msg ? msg : 'Processing...');
  }

  unBlockUI() {
    this.blockUi!.stop();
  }

  successMessage(message: string, title = '', options = {}) {
    this.toastrService.success(message, title, options);
  }

  errorMessage(message: string) {
    this.toastrService.error(message);
  }

  infoMessage(message: string, title = '', options = {}) {
    this.toastrService.info(message, title, options);
  }

  getSyncChannelName(user: any): string {
    return (user && user.default_team)
      ? 'team-channel-' + user.default_team.uid
      : 'user-channel-' + user.uid;
  }

  subscribeToSyncNotifications(user: any, onMessage: (message: string) => void) {
    const channel = this.pusherService.subscribe(this.getSyncChannelName(user));
    channel?.bind('refresh-from-drive', (data: any) => onMessage(data.message));
    return channel;
  }

  unsubscribeFromSyncNotifications(user: any) {
    this.pusherService.unsubscribe(this.getSyncChannelName(user));
  }

  pdfErrorMessage(message){
    this.toastrService.error(message,'',{timeOut:10000});
  }

  navigateToUrl(url: string) {
    this._router.navigateByUrl(url);
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  openModal<T extends Modal>(component: Type<T>, inputData?: any): ModalRef {
    return this.modalService.open(component, inputData);
  }

  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(null), ms));
  }

  truncateString(text: string, limit: number) {
    return (text.length < limit) ? text : text.substring(0, limit) + '...';
  }

  getTags() {
    return [
      'All', 'General Business', 'Technology', 'Professional Services', 'Real Estate', 'Due-Diligence', 'Marketing', 'Proposals', 'RFPs'
    ];
  }

  getKnowledgebaseTags() {
    return [
      'All', 'Getting Started', 'Templates', 'Projects', 'Forms & Fields', 'Tables', 'Maps', 'Content Library', 'Database', 'Signatures & Tracking'
    ];
  }

  getSanitizeHtml(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  encodeSingleAndDoubleQuots(text: string) {
    if (/'/.test(text) == true) {
      return text.replace(/'/g, "&apos;");
    } else if (/"/.test(text) == true) {
      return text.replace(/"/g, "&quot;");
    }
    return text;
  }

  getGoogleDriveFolderUrl(google_drive_folder_id: string) {
    return 'https://drive.google.com/drive/u/0/folders/' + google_drive_folder_id;
  }

  
  isSyncPending(project: any, staleAfterSeconds: number): boolean {
    if (project.is_standAlone || project.drive_sync_at) {
      return false;
    }

    if (!project.updated_at) {
      return true;
    }

    const secondsSinceUpdate = (Date.now() - new Date(project.updated_at).getTime()) / 1000;
    return secondsSinceUpdate < staleAfterSeconds;
  }

  bindJqueryDropdown(toggleActionClass: string = 'dropdown-toggle-action', toggleMenuClass: string = 'dropdown-menu') {
    if (isPlatformBrowser(this.platformId)) {
      var menu = function () {
        $('.' + toggleActionClass).click(function (e: any) {
          if ($('.' + toggleMenuClass).hasClass('hidden')) {
            $('.' + toggleMenuClass).removeClass('hidden').addClass('block');
          }

          else if ($('.' + toggleMenuClass).hasClass('block')) {
            $('.' + toggleMenuClass).removeClass('block').addClass('hidden');
          }
        });

        $(document).click(function (e: any) {
          var target = e.target;
          if (!$(target).is('.' + toggleActionClass) && !$(target).parents().is('.' + toggleActionClass)) {
            $('.' + toggleMenuClass).addClass('hidden');
          }
        });
      }
      setTimeout(menu, 1500);
    }

  }

  bindWindowClickEvent(toggleActionClass: any, toggleMenuClass: any) {
    if (isPlatformBrowser(this.platformId)) {
      $(document).click(function (e: any) {
        var target = e.target;
        if (!$(target).is('.' + toggleActionClass) && !$(target).parents().is('.' + toggleActionClass)) {
          $('.' + toggleMenuClass).hide();
        }
      });
    }
  }

  jumpToPreviousPage() {
    if (isPlatformBrowser(this.platformId)) {
      window.history.back();
    }
  }

  isMobile() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    let mediaQueryList = window.matchMedia("(max-width: 1023px)");
    return mediaQueryList.matches;

    // var userAgent : any = navigator.userAgent || navigator.vendor || null;
    // var userAgentPart = userAgent.substr(0, 4);
    // // return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor).substr(0, 4)))
    // return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent)
    //   || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgentPart));
  }

  getViewportDimensions() {
    if (!isPlatformBrowser(this.platformId)) return {};

    return { height: window.innerHeight, width: window.innerWidth }
  }

  getElementPosition(element: HTMLElement) {
    if (!isPlatformBrowser(this.platformId)) return {};
    return element.getBoundingClientRect();
  }

  isInViewport(element: HTMLElement) {
    var rect = element.getBoundingClientRect();
    var viewportHeight: any = this.getViewportDimensions().height;
    var position = rect.top / viewportHeight;
    if (position >= 0 && position <= 1) {
      return true;
    }
    else {
      return false;
    }
  }

  static getLogo(type) {
    // 1 : Default, 2 : Dashboard, 3: Team Docs
    if (type == 1) {
      return {
        src: 'assets/images/logo/startdeck.svg',
        alt: 'StartDeck',
        // srcset: 'assets/images/logo/startdeck-logo-lg@2x.png 2x, assets/images/logo/startdeck-logo-lg@3x.png 3x'
      }
    }

    else if (type == 2) {
      return {
        src: 'assets/images/logo/startdeck-dashboard.svg',
        alt: 'StartDeck Dashboard',
        // srcset: 'assets/images/logo/startdeck-dashboard@2x.png 2x, assets/images/logo/startdeck-dashboard@3x.png 3x'
      }
    }

    else if (type == 3) {
      return {
        src: 'assets/images/logo/startdeck-team-docs.svg',
        alt: 'StartDeck Team Docs',
        // srcset: 'assets/images/logo/startdeck-team-docs@2x.png 2x, assets/images/logo/startdeck-team-docs@3x.png 3x'
      }
    }
  }
}
